/**
 * Navigations-Labels der Admin-Sidebar (Namespace `nav`).
 * Ergänzt/überschreibt die in src/i18n/index.ts vorhandenen nav-Keys.
 */
export const nav = {
  de: {
    nav: {
      dashboard: 'Dashboard',
      calendar: 'Kalender',
      appointments: 'Termine',
      reminders: 'Erinnerungen',
      recalls: 'Recalls',
      patients: 'Patienten',
      intake: 'Erhebungsbögen',
      invoices: 'Belege',
      reports: 'Auswertungen',
      eventLog: 'Event Log',
      settings: 'Einstellungen',
      help: 'Hilfe',
      logout: 'Abmelden',
      openSidebar: 'Sidebar öffnen',
      closeSidebar: 'Sidebar schließen',
      support: 'Support & Anfragen',
    },
  },
  es: {
    nav: {
      dashboard: 'Panel',
      calendar: 'Calendario',
      appointments: 'Citas',
      reminders: 'Recordatorios',
      recalls: 'Recalls',
      patients: 'Pacientes',
      intake: 'Cuestionarios',
      invoices: 'Facturas',
      reports: 'Análisis',
      eventLog: 'Registro de eventos',
      settings: 'Ajustes',
      help: 'Ayuda',
      logout: 'Cerrar sesión',
      openSidebar: 'Abrir menú lateral',
      closeSidebar: 'Cerrar menú lateral',
      support: 'Soporte y consultas',
    },
  },
};
